import request from "@/utils/request";
import service from "@/utils/axios-v2";
// let basic = 'http://18.184.253.48:8088'


function getUser() {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: "/zuul/user/company/profile",
    headers: {
      "portal-token": true
    }
  })
}

function invitationList(data) {
  return request({
    method: 'GET',
    // baseURL: basic,
    params: data,
    url: "/fleet/user/v2/invitation/query",
    headers: {
      "portal-token": true
    }
  })
}

function editInvitation(data) {
  return request({
    method: 'put',
    // baseURL: basic,
    params: data,
    url: "/fleet/user/v2/invitation/edit",
    headers: {
      "portal-token": true
    }
  })
}

function groupList(data) {
  return request({
    method: 'GET',
    // baseURL: basic,
    params: data,
    url: "/fleet/user/v2/group/query",
    headers: {
      "portal-token": true
    }
  })
}
function groupAdd(data) {
  return request({
    method: 'GET',
    // baseURL: basic,
    params: data,
    url: "/fleet/user/v2/group/add",
    headers: {
      "portal-token": true
    }
  })
}
function groupDel(data) {
  return request({
    method: 'GET',
    // baseURL: basic,
    params: data,
    url: "/fleet/user/v2/group/delete",
    headers: {
      "portal-token": true
    }
  })
}

function setPassword(data) {
  return request({
    method: 'post',
    baseURL: process.env.VUE_APP_COMMAND_CENTER,

    data,
    // url: "/fleet/user/v2/password_set",
    url: "/zuul/user/change/password",
    headers: {
      "portal-token": true
    }
  })
}

function editMeInfo(data) {
  return request({
    method: 'put',
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    data,
    url: "/zuul/user/company/update",
    headers: {
      "portal-token": true
    }
  })
}


function addInvitation(data) {
  return request({
    method: 'put',
    // baseURL: basic,
    data: data.list,
    params: {role: data.role},
    url: "/fleet/user/v2/invitation/operator",
    headers: {
      "portal-token": true
    }
  })
}

function delInvitation(data) {
  return request({
    method: 'put',
    // baseURL: basic,
    params: data,
    url: "/fleet/user/v2/invitation/delete",
    headers: {
      "portal-token": true
    }
  })
}

function groupEdit(data) {
  return request({
    method: 'GET',
    // baseURL: basic,
    params: data,
    url: "/fleet/user/v2/group/edit",
    headers: {
      "portal-token": true
    }
  })
}

function getGroup(data) {
  return service({
    url: "/fleet/user/group_member_query",
    params: data,
    headers: {
      "portal-token": true
    }
  });
}

function addMembersToGroup({ groupId, userIds }) {
  return service({
    url: "/fleet/user/add_member_to_group",
    method: "post",
    params: { groupId },
    data: { idList: userIds },
    headers: {
      "portal-token": true
    }
  });
}

function removeMemberFromGroup(params) {
  return service({
    url: "/fleet/user/delete_member_in_group",
    params,
    headers: {
      "portal-token": true
    }
  });
}
// resendInvite
function resendInvite(data) {
  return request({
    // baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: "/fleet/user/v2/resend-invitation/operator",
    method: "PUT",
    data,
    headers: {
      "portal-token": true,
    },
  });
}
export {
  getUser,
  invitationList,
  editInvitation,
  groupList,
  groupAdd,
  groupDel,
  setPassword,
  editMeInfo,
  groupEdit,
  getGroup,
  addInvitation,
  delInvitation,
  addMembersToGroup,
  removeMemberFromGroup,
  resendInvite,
}